import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { useValidateParamGuard } from '@/composables/useValidateResourceGuard'
import { getSiteActive } from '@/services/api/sites.api'
import { NOT_FOUND_REASONS_ENUM } from '@/utils/constants/not-found-reasons'

export const validateResourceHook = {
  async beforeEachAuthenticated(to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) {
    const requiresActiveSite = to.matched.some(record => record.meta?.requiresActiveSite)

    if (!requiresActiveSite) {
      return
    }

    const guard = useValidateParamGuard('siteId', getSiteActive, { name: 'not-found', params: { reason: NOT_FOUND_REASONS_ENUM.SiteExpired } })
    const result = await guard(to)

    if (result !== true) {
      if (result === false) {
        next(false)
      }
      else {
        next(result)
      }
    }
  },
}
